import React from "react";
import ToolsGrid from "../components/ToolsGrid";

export default function Home() {
  return (
    <div style={{ maxWidth: 1100, margin: "0 auto", padding: 16 }}>
      <h1 style={{ marginBottom: 8 }}>Outils Immobilier gratuits</h1>
      <p style={{ marginTop: 0, opacity: 0.75 }}>
        Simulateurs et documents utiles : achat, investissement, vente.
      </p>

      <ToolsGrid />
    </div>
  );
}
